import { render } from "./SubAdds.vue?vue&type=template&id=0b3491df"
import script from "./SubAdds.vue?vue&type=script&lang=js"
export * from "./SubAdds.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__